import { render, staticRenderFns } from "./AddIconSimple.vue?vue&type=template&id=72da0400&scoped=true&"
import script from "./AddIconSimple.vue?vue&type=script&lang=js&"
export * from "./AddIconSimple.vue?vue&type=script&lang=js&"
import style0 from "./AddIconSimple.vue?vue&type=style&index=0&id=72da0400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da0400",
  null
  
)

export default component.exports